import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3, _Skeleton;

import React, { useState, useRef, useEffect } from 'react';
import styled from 'styled-components';
import { DownOutlined } from '@ant-design/icons';
import Space from '../Space';
import Skeleton from '../Skeleton';
import Typography from '../Typography';
import { setLightness } from "polished";
var BODY_VERTICAL_PADDING = '1.5rem';
var BODY_HORIZONTAL_PADDING = '1rem';
var SectionWrapper = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n"])));
var SectionHead = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 0.5rem;\n  cursor: ", ";\n\n  & > * {\n    margin: 0 !important;\n  }\n"])), function (props) {
  return props.collapsible && 'pointer';
});
var SectionBody = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  background-color: ", ";\n  padding: ", ";\n  overflow: hidden;\n  transition: all ease-out 0.3s;\n"])), function (props) {
  return props.withoutBase ? 'transparent' : setLightness(0.925, props.theme.colors.grey);
}, function (props) {
  return props.withoutBase || props.collapse ? '0' : "".concat(BODY_VERTICAL_PADDING, " ").concat(BODY_HORIZONTAL_PADDING);
});

var Section = function Section(_ref) {
  var children = _ref.children,
      _ref$collapsible = _ref.collapsible,
      collapsible = _ref$collapsible === void 0 ? false : _ref$collapsible,
      headClasses = _ref.headClasses,
      _ref$hideHeader = _ref.hideHeader,
      hideHeader = _ref$hideHeader === void 0 ? false : _ref$hideHeader,
      _ref$initialCollapse = _ref.initialCollapse,
      initialCollapse = _ref$initialCollapse === void 0 ? false : _ref$initialCollapse,
      _ref$loading = _ref.loading,
      loading = _ref$loading === void 0 ? false : _ref$loading,
      _ref$subtitle = _ref.subtitle,
      subtitle = _ref$subtitle === void 0 ? '' : _ref$subtitle,
      title = _ref.title,
      titleClasses = _ref.titleClasses,
      _ref$titleLevel = _ref.titleLevel,
      titleLevel = _ref$titleLevel === void 0 ? 4 : _ref$titleLevel,
      _ref$withoutBase = _ref.withoutBase,
      withoutBase = _ref$withoutBase === void 0 ? true : _ref$withoutBase,
      wrapperClasses = _ref.wrapperClasses;

  var _useState = useState(initialCollapse),
      _useState2 = _slicedToArray(_useState, 2),
      isCollapsed = _useState2[0],
      setIsCollapsed = _useState2[1];

  var bodyRef = useRef();
  useEffect(function () {
    var resizeObserver = {};

    if (collapsible) {
      resizeObserver = new ResizeObserver(function (entries) {
        if (entries.length > 0) {
          // eslint-disable-next-line max-len
          var fullHeight = "calc(".concat(entries[0].target.scrollHeight, "px + ").concat(BODY_VERTICAL_PADDING, " + ").concat(BODY_VERTICAL_PADDING, ")");

          if (bodyRef !== null && bodyRef !== void 0 && bodyRef.current) {
            bodyRef.current.style['max-height'] = isCollapsed ? '0px' : fullHeight;
          }
        }
      });

      if (bodyRef.current) {
        resizeObserver.observe(bodyRef.current);
      }
    }

    return function () {
      if (collapsible) {
        resizeObserver.disconnect();
      }
    };
  }, [isCollapsed, collapsible]);
  return /*#__PURE__*/React.createElement(SectionWrapper, {
    className: wrapperClasses
  }, !hideHeader && /*#__PURE__*/React.createElement(SectionHead, {
    className: headClasses,
    collapsible: collapsible,
    onClick: function onClick() {
      return collapsible && setIsCollapsed(!isCollapsed);
    }
  }, loading ? /*#__PURE__*/React.createElement(Skeleton.Input, {
    active: true,
    style: {
      width: '50%'
    }
  }) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Space, null, /*#__PURE__*/React.createElement(Typography.Title, {
    level: titleLevel,
    className: titleClasses
  }, title), collapsible && /*#__PURE__*/React.createElement(DownOutlined, {
    style: {
      transform: isCollapsed && 'rotate(-90deg)',
      transition: 'all ease-out 0.3s'
    }
  })), /*#__PURE__*/React.createElement(Typography.Text, {
    type: "secondary"
  }, subtitle))), /*#__PURE__*/React.createElement(SectionBody, {
    ref: bodyRef,
    withoutBase: withoutBase,
    collapse: isCollapsed
  }, loading ? _Skeleton || (_Skeleton = /*#__PURE__*/React.createElement(Skeleton, {
    active: true
  })) : children));
};

export default Section;